import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskedLines, Reveal } from "@/components/Reveal";
import { ARTICLES, IMAGES } from "@/data/content";

const Journal = () => (
  <motion.main
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
    data-testid="journal-page"
    className="pt-16"
  >
    <section className="relative overflow-hidden py-24 sm:py-28">
      <div
        className="pointer-events-none absolute -right-40 top-0 h-[420px] w-[420px] rounded-full blur-[150px]"
        style={{ background: "radial-gradient(circle, rgba(204,10,20,0.16), transparent 65%)" }}
      />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-jb text-xs uppercase tracking-[0.3em] text-[#CC0A14]"
        >
          The Journal — Longform
        </motion.p>
        <MaskedLines
          lines={["READ IT.", "THEN RUN IT."]}
          className="mt-6 font-syne text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[1.02] tracking-tight text-white"
        />
      </div>
    </section>

    <section className="pb-24 sm:pb-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        {ARTICLES.map((a, i) => (
          <Reveal key={a.slug} delay={i * 0.05}>
            <Link
              to={`/journal/${a.slug}`}
              data-testid={`journal-row-${a.slug}`}
              className="group grid grid-cols-1 items-center gap-6 border-t border-[#27272A] py-10 transition-colors duration-500 last:border-b hover:bg-[#0c0c0e] sm:grid-cols-12 sm:gap-10"
            >
              <span className="font-syne text-5xl font-extrabold text-outline transition-colors duration-500 group-hover:text-[#CC0A14] group-hover:[-webkit-text-stroke:0px] sm:col-span-2 sm:text-6xl sm:pl-4">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="relative h-44 overflow-hidden border border-[#27272A] sm:col-span-3">
                <img
                  src={IMAGES[a.image]}
                  alt={a.title}
                  loading="lazy"
                  className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                />
              </div>
              <div className="sm:col-span-6">
                <div className="flex items-center gap-4">
                  <span className="font-jb text-[10px] uppercase tracking-[0.22em] text-[#CC0A14]">
                    {a.category}
                  </span>
                  <span className="font-jb text-[10px] uppercase tracking-[0.22em] text-zinc-600">
                    {a.readTime}
                  </span>
                </div>
                <h2 className="mt-3 font-syne text-xl font-bold leading-snug tracking-tight text-white transition-colors duration-300 group-hover:text-[#CC0A14] sm:text-2xl">
                  {a.title}
                </h2>
                <p className="mt-3 max-w-xl text-sm leading-relaxed text-zinc-500">{a.excerpt}</p>
              </div>
              <span className="hidden justify-end pr-4 text-zinc-600 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#CC0A14] sm:col-span-1 sm:flex">
                <ArrowUpRight size={26} />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  </motion.main>
);

export default Journal;
